module.exports = __webpack_public_path__ + "img/z12.68555a6c.gif";